<template>
	<div
		v-show="$root.source !== 'enel'"
		class='row-option flex flex-center'
		@click="$emit('onClick')"
	>
		<div
			class="checkbox"
			:checked="checked"
			v-if="hasCheck"
		>
			<i class="fas fa-check" />
		</div>
		<div
			class="label"
			v-html="label"
		/>
		<div
			class='price flex-right'
			v-html="price"
		/>
	</div>
</template>

<script>

export default {
	props: {
		hasCheck: {
			type: Boolean,
			default: true
		},
		checked: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: null
		},
		price: {
			type: String,
			default: ''
		}
	}
}

</script>

<style scoped>
.row-option {
	border-radius: 4px;
	/*cursor: pointer;*/
	-webkit-transition: border-color .3s;
	transition: border-color .3s;
	display: flex;
	justify-content: flex-start;
	width: calc(100% + 20px);
	padding: 10px;
	margin-left: -10px;
}
.label {
	font-weight: bold;
}
.row-option:hover {
	/*background-color: #EDEDED;*/
}

.price {
	color:var(--quomi-primary);
}

.checkbox[checked] {
	background: var(--quomi-primary);
	border-color: var(--quomi-primary);
}

.fa-check {
	color: white;
	font-size: 18px;
	padding: 5px;
}

.checkbox {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	border: 1.5px solid var(--quomi-primary);
	background: #ffffff;
	border-radius: 4px;
	margin-right: 10px;

	-webkit-transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, transform .3s, border-color .3s;
	transition: background-color .3s, transform .3s, border-color .3s, -webkit-transform .3s;
}
</style>
